import {DeepPartial} from 'react-hook-form';

import {AuthorizedPersonRequestBody} from '@dms/api/rental';
import {useTenant} from '@dms/shared';

export const useGetEmptyAuthorizedPerson = (): AuthorizedPersonRequestBody => {
  const {tenantPhoneInfo} = useTenant();

  const emptyAuthorizedPerson: DeepPartial<AuthorizedPersonRequestBody> = {
    name: undefined,
    idCardNumber: null,
    drivingLicenceNumber: null,
    phoneNumber: {
      countryCode: tenantPhoneInfo?.countryCode,
      prefix: tenantPhoneInfo?.prefix,
      number: undefined,
    },
  };

  return emptyAuthorizedPerson as AuthorizedPersonRequestBody;
};
